import TotalResultsWrapper from './TotalResultsWrapper';
import ViewResultBtnWrapper from './ViewResultBtnWrapper';

export { TotalResultsWrapper, ViewResultBtnWrapper };
